// extracted by mini-css-extract-plugin
module.exports = {"formStyle":"EmailInput_formStyle__eMN0X","inputStyle":"EmailInput_inputStyle__hBAaU","sendIcon":"EmailInput_sendIcon__2pw8Q","sendText":"EmailInput_sendText__1s_LT"};